import compact from 'lodash/compact';

import { IPolicyVehicle, IVehicle } from '../../interfaces';

export function getVehicleName(
  vehicle: IVehicle | IPolicyVehicle,
  vehicleProperties: (keyof (IVehicle | IPolicyVehicle))[] = [
    'year',
    'make',
    'model',
    'style',
  ]
) {
  return compact(vehicleProperties.map((property) => vehicle[property])).join(
    ' '
  );
}
